import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import moment from 'moment';
import { Card, Spinner, Alert, ListGroup, Container } from 'react-bootstrap';

const OpeningHoursDisplay = () => {
    const [shopHours, setShopHours] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchShopHours = async () => {
            try {
                const response = await api.get('/opening-hours');
                setShopHours(response.data);
            } catch (err) {
                setError('Could not retrieve opening hours at this time.');
            } finally {
                setLoading(false);
            }
        };
        fetchShopHours();
    }, []);

    if (loading) {
        return <Container className="text-center mt-5"><Spinner animation="border" /></Container>;
    }

    if (error) {
        return <Container className="mt-5"><Alert variant="danger">{error}</Alert></Container>;
    }

    const today = moment().format('dddd');
    const todayHoliday = shopHours.holidays.find(holiday => moment(holiday.date).isSame(moment(), 'day'));
    const upcomingHolidays = shopHours.holidays
        .filter(holiday => moment(holiday.date).isAfter(moment(), 'day'))
        .sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf());

    return (
        <Container className="my-5">
            <Card className="shadow-sm">
                <Card.Header as="h5">Opening Hours</Card.Header>
                <Card.Body>
                    {todayHoliday ? (
                        <Alert variant="info">
                            We are **closed today** for: **{todayHoliday.description}**
                        </Alert>
                    ) : (
                        <ListGroup variant="flush">
                            {shopHours.openingHours.map(day => (
                                <ListGroup.Item key={day.day} className={day.day === today ? 'bg-light' : ''}>
                                    <div className="d-flex justify-content-between">
                                        <strong>{day.day}:</strong>
                                        <span>
                                            {day.isClosed ? 'Closed' : `${day.openTime} - ${day.closeTime}`}
                                        </span>
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Card.Body>
            </Card>

            {upcomingHolidays.length > 0 && (
                <Card className="mt-4 shadow-sm">
                    <Card.Header as="h5">Upcoming Holidays</Card.Header>
                    <ListGroup variant="flush">
                        {upcomingHolidays.map(holiday => (
                            <ListGroup.Item key={holiday._id}>
                                <div className="d-flex justify-content-between">
                                    <strong>{moment(holiday.date).format('MMMM Do, YYYY')}</strong>
                                    <span>{holiday.description}</span>
                                </div>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Card>
            )}
        </Container>
    );
};

export default OpeningHoursDisplay;